var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9979 0V13.716L11.9979 20.573L-0.0020752 13.715L23.9979 0Z",
    fill: "#431F5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.572L24 27.429V41.143L12 34.286L0 27.429V13.714L12 20.572Z",
    fill: "#722ED1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.999 34.286V47.999L23.999 41.143V27.429L35.999 34.286Z",
    fill: "#722ED1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9979 0V13.714L35.9979 20.57L47.9979 27.426V13.715L23.9979 0Z",
    fill: "#722ED1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9969 13.714V27.43L35.9969 34.287L23.9969 27.429L35.9969 20.571L47.9969 13.714Z",
    fill: "#431F5A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.999 34.286L23.999 41.143V27.429L35.999 34.286Z",
    fill: "#431F5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.83bf302fd0617ee1683e7ca35307a66d.svg";
export { ForwardRef as ReactComponent };